export function getDealerLocatorType(sitecoreContext) {
  const componentList = sitecoreContext?.route?.placeholders['jss-main'];
  const dealerLocatorLandingIndex = componentList?.findIndex((item) => item?.componentName === 'DealerLocatorLanding');
  const dealerLocatorLandingComponent = componentList?.[dealerLocatorLandingIndex];

  return dealerLocatorLandingComponent?.fields?.settings?.dealerLocatorSearchType;
}
